// extracted by mini-css-extract-plugin
module.exports = {"separator":"clinical-portal-3__SectionSeparator__separator"};